import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendUrl } from 'src/backendUrl';
import * as io from 'socket.io-client';
@Injectable({
  providedIn: 'root'
})
export class SocketService {                               
  observable: Observable<any> | any;
  socket: any;
  constructor() {
    this.socket = io.connect('https://stageapi.sastanet.org/', { transports: ['websockets', 'polling'] });
    console.log("🚀 ~ file: socket.service.ts:13 ~ SocketService ~ constructor ~ this.socket:", this.socket)
  }

  latestBlocks(): Observable<any> {
    return this.observable = new Observable((observer) => {
      this.socket.on('latestblocks', (message: any) => {
        observer.next(message);
      });
    });
  }
}
